import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Button, Input } from '@costar/theme-ui';
import React, { useCallback, useMemo } from 'react';
import { IconClose } from '@costar/theme-ui-icons/csg/IconClose';
import { IconSearch } from '@costar/theme-ui-icons/csg/IconSearch';

var _excluded = ["search", "setSearch", "optionList", "setHighlightedStrings", "onChange", "value", "size", "isClearable", "placeholder"];
var ButtonIcon = /*#__PURE__*/React.createElement(IconClose, null);
var SearchInput = function SearchInput(props) {
  var search = props.search,
    setSearch = props.setSearch;
    props.optionList;
    props.setHighlightedStrings;
    props.onChange;
    props.value;
    var size = props.size,
    _props$isClearable = props.isClearable,
    isClearable = _props$isClearable === void 0 ? true : _props$isClearable,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'Search Items' : _props$placeholder,
    rest = _objectWithoutProperties(props, _excluded);
  var onInputChange = useCallback(function (e) {
    var value = e.currentTarget.value;
    setSearch(value);
  }, [setSearch]);
  var handleClear = useCallback(function (_e) {
    setSearch('');
  }, [setSearch]);
  var after = useMemo(function () {
    return search === '' || !isClearable ? /*#__PURE__*/React.createElement(IconSearch, {
      color: "neutral.dark"
    }) : /*#__PURE__*/React.createElement(Button, {
      variant: "icon.clear",
      icon: ButtonIcon,
      size: size,
      p: "xs-3",
      onClick: handleClear
    });
  }, [handleClear, isClearable, search, size]);
  return /*#__PURE__*/React.createElement(Input, _extends({
    after: after,
    size: size,
    placeholder: placeholder,
    value: search,
    onChange: onInputChange
  }, rest));
};

export default SearchInput;
//# sourceMappingURL=fuzzy-search-input.esm.js.map
